module.exports = __webpack_public_path__ + "static/media/Beijing.66640853.jpg";